/* A single row in the AutoCompleteResults dropdown representing a search result */

import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';
import _Row from "AutoCompleteResultRow-Row.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResultRow.tsx?styleId=Row";
import _ResultIcon from "AutoCompleteResultRow-ResultIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResultRow.tsx?styleId=ResultIcon";
import _EntityContent from "AutoCompleteResultRow-EntityContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResultRow.tsx?styleId=EntityContent";
import _Name from "AutoCompleteResultRow-Name.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResultRow.tsx?styleId=Name";
import _Description from "AutoCompleteResultRow-Description.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResultRow.tsx?styleId=Description";
import _ResultImage from "AutoCompleteResultRow-ResultImage.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResultRow.tsx?styleId=ResultImage";


const Row = /*#__PURE__*/styled("a", null, {
  displayName: "Row",
  styles: _Row
});

const ResultIcon = /*#__PURE__*/styled("div", null, {
  displayName: "ResultIcon",
  styles: _ResultIcon
});

const EntityContent = /*#__PURE__*/styled("div", null, {
  displayName: "EntityContent",
  styles: _EntityContent
});

const Name = /*#__PURE__*/styled("span", null, {
  displayName: "Name",
  styles: _Name
});

// DESIGN: gray is hard to see
const Description = /*#__PURE__*/styled("span", null, {
  displayName: "Description",
  styles: _Description
});

const ResultImage = /*#__PURE__*/styled("img", null, {
  displayName: "ResultImage",
  styles: _ResultImage
});

const Avatar = ({ photoUrl }: { photoUrl: string }) => {
  const url = photoUrl != null ? photoUrl : $image_url('s65_no_pic.png');
  return <ResultImage src={url} />;
};

// TODO: camelize results from controller
export type SearchResult = {
  display_name: string;
  description?: string;
  image_url?: string;
  entity_url: string;
  type: 'User' | 'ResearchInterest' | 'University' | 'Query';
  onClick?: (e: React.MouseEvent) => void;
};

const AutoCompleteResultRow = ({
  display_name,
  description,
  image_url,
  entity_url,
  type,
  onClick,
}: SearchResult) => (
  <Row href={entity_url} onClick={onClick}>
    {type === 'User' ? (
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      <Avatar photoUrl={image_url} />
    ) : (
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      <ResultIcon blue={type === 'Query'}>
        {type === 'Query' ? (
          <i className="fa fa-search" />
        ) : type === 'University' ? (
          <i className="fa fa-university" />
        ) : (
          <i className="fa fa-tag" />
        )}
      </ResultIcon>
    )}
    <EntityContent>
      <Name>
        {type === 'Query' && 'Papers matching "'}
        {display_name}
        {type === 'Query' && '"'}
      </Name>
      <Description>{description}</Description>
    </EntityContent>
  </Row>
);

export default AutoCompleteResultRow;
